var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ON_VEHICLE_RESOLVED } from "../../vehicleInfo";
import { VEHICLE_GET_VEHICLE_DATA_SUCCESS, VEHICLE_ON_CHANGE_VEHICLE_STATE, VEHICLE_GET_VEHICLE_META_DATA_SUCCESS, VEHICLE_ON_RESET_VEHICLE, VEHICLE_ON_RESET_VEHICLE_DATA, VEHICLE_UPDATE_VEHICLE_DESCRIPTION, VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME, VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME_CHECKBOX, VEHICLE_ADMIN_CUSTOM_FIELD_VALIDATION_RECEIVED, VEHICLE_UPDATE_SALVAGE_VALUE } from '../actions';
import { REDBOOK_CONTROL_NUMBER_ATTRIBUTE_LABEL } from '../constants';
import { vehicleResolvedReducer } from './vehicleResolvedReducer';
const defaultState = {};
export const vehicleRootReducer = (state = defaultState, action) => {
    switch (action.type) {
        case VEHICLE_GET_VEHICLE_DATA_SUCCESS: {
            const _a = action.payload, { description, customVehicleName, salvageValue } = _a, payload = __rest(_a, ["description", "customVehicleName", "salvageValue"]);
            return Object.assign(Object.assign(Object.assign({}, state), payload), { description: Object.assign(Object.assign({}, state.description), { value: description === null || description === void 0 ? void 0 : description.value }), customVehicleName: customVehicleName, salvageValue: Object.assign(Object.assign({}, state.salvageValue), { value: salvageValue === null || salvageValue === void 0 ? void 0 : salvageValue.value }) });
        }
        case VEHICLE_GET_VEHICLE_META_DATA_SUCCESS: {
            return Object.assign(Object.assign({}, state), { vehicleMetaData: action.payload });
        }
        case VEHICLE_ON_CHANGE_VEHICLE_STATE: {
            const vehicleChangeList = action.payload.items;
            const newState = Object.assign({}, state);
            vehicleChangeList.forEach(key => {
                switch (key.name) {
                    case REDBOOK_CONTROL_NUMBER_ATTRIBUTE_LABEL:
                        newState.redbookControlNumber = key.value;
                        break;
                    default:
                        newState[key.name] = key.value;
                }
            });
            return newState;
        }
        case VEHICLE_ON_RESET_VEHICLE: {
            return Object.assign(Object.assign({}, defaultState), { description: state.description, salvageValue: state.salvageValue });
        }
        case VEHICLE_ON_RESET_VEHICLE_DATA: {
            return defaultState;
        }
        case ON_VEHICLE_RESOLVED: {
            return vehicleResolvedReducer(state, action);
        }
        case VEHICLE_UPDATE_VEHICLE_DESCRIPTION: {
            return Object.assign(Object.assign({}, state), { description: Object.assign(Object.assign({}, state.description), { value: action.payload }) });
        }
        case VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME: {
            return Object.assign(Object.assign({}, state), { customVehicleName: action.payload });
        }
        case VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME_CHECKBOX: {
            return Object.assign(Object.assign({}, state), { isCustomVehicleNameSelected: !state.isCustomVehicleNameSelected, customVehicleName: defaultState.customVehicleName });
        }
        case VEHICLE_UPDATE_SALVAGE_VALUE: {
            return Object.assign(Object.assign({}, state), { salvageValue: Object.assign(Object.assign({}, state.salvageValue), { value: action.payload }) });
        }
        case VEHICLE_ADMIN_CUSTOM_FIELD_VALIDATION_RECEIVED: {
            return handleAdminCustomFieldValidations(state, action);
        }
        default:
            return state;
    }
};
const handleAdminCustomFieldValidations = (state, action) => {
    return Object.assign(Object.assign({}, state), { description: Object.assign(Object.assign({}, state.description), getValidationDataFrom(action.payload.description)), salvageValue: Object.assign(Object.assign({}, state.salvageValue), getValidationDataFrom(action.payload.salvageValue)) });
};
const getValidationDataFrom = (validationsData) => {
    return {
        isRequired: validationsData === null || validationsData === void 0 ? void 0 : validationsData.required,
        isReadOnly: validationsData === null || validationsData === void 0 ? void 0 : validationsData.readOnly,
        isVisible: validationsData === null || validationsData === void 0 ? void 0 : validationsData.visible
    };
};
//# sourceMappingURL=vehicleRootReducer.js.map